<template>
    <Toast
        position="bottom-right"
        group="gateway-timeout-toast"
    >
        <template #container="{ message, closeCallback }">
            <section class="flex flex-col p-4 gap-4 w-full bg-primary/70 rounded-xl">
                <div class="flex items-center gap-5">
                    <i class="pi pi-exclamation-circle text-2xl"></i>
                    <span class="font-bold text-2xl">{{ message.summary }}</span>
                </div>
                <span class="text-base">{{ message.detail }}</span>
                <div class="flex gap-6 mb-4 justify-center">
                    <Button
                        label="Go back"
                        severity="danger"
                        @click="() => {
                            goBack()
                            closeCallback()
                        }"
                    ></Button>
                    <Button
                        label="Close"
                        severity="danger"
                        outlined
                        size="small"
                        @click="closeCallback"
                    ></Button>
                </div>
            </section>
        </template>
    </Toast>
</template>
<script setup lang="ts">
import { useWorkspace } from '@/modules/workspaces/composables/useWorkspace'
import { useRouter } from 'vue-router'

const router = useRouter()
const { currentWorkspaceId } = useWorkspace()

const goBack = () => {
    if (window.history.length > 1) {
        router.go(-1)
        return
    }
    router.push({ name: 'workspace-home', params: { workspaceId: currentWorkspaceId.value } })
}
</script>
